module.exports = __webpack_public_path__ + "img/smile.49c9fbc3.png";